import { z } from 'zod';

export const AcademicYearConfigSchema = z.object({
  label: z.string(),
  startDate: z.string(),
  endDate: z.string(),
}).passthrough();
export type AcademicYearConfig = z.infer<typeof AcademicYearConfigSchema>;
